import { render, staticRenderFns } from "./StaticInfos.vue?vue&type=template&id=715bd97e&scoped=true"
import script from "./StaticInfos.vue?vue&type=script&lang=js"
export * from "./StaticInfos.vue?vue&type=script&lang=js"
import style0 from "./StaticInfos.vue?vue&type=style&index=0&id=715bd97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715bd97e",
  null
  
)

export default component.exports